export default __webpack_public_path__ + "static/media/date-icon.066a0ba0.svg";